

(function() {'use strict';
    angular.module('quantixApp').controller('EconomicIndicatorsController', EconomicIndicatorsController);
    
    EconomicIndicatorsController.$inject = ['$scope', 'GenericService', 'GenericServiceNew', 'EconomicIndicatorService', '$http','$timeout', '$state', '$uibModal', '$filter', '$window', '$sce', 'AuthKeycloak'];

    function EconomicIndicatorsController($scope, GenericService, GenericServiceNew, EconomicIndicatorService, $http,$timeout, $state, $uibModal, $filter, $window, $sce, AuthKeycloak)  {

        $scope.ecoCategory = 'moneyBanking';     
        $scope.posi = true;
        $scope.negi = false;
        var financialGrid = '';
        $scope.selectedCategory = '6';
        $scope.categories = [];
		$scope.summPeriod = '30';
		$scope.period = '30';
		$scope.selectedSubCategory = '1';
		$scope.porttoDate = '';
		$scope.portfromDate = '';
		$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.errorFilter = false;
		$scope.source = '';
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];
		$scope.startMaxDate = new Date();
		$scope.startMaxDate.setFullYear(new Date().getFullYear() - 15);
		$scope.endMaxDate = new Date();
		$scope.format = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];
		$scope.dataDenomination = '';
		$scope.selectedGraph = "Line Graph";
		$scope.frequency = '';
		$scope.oneWeekFlag = false;
		$scope.oneMonFlag = false;
		$scope.threeMonFlag = false;
		$scope.sixMonFlag = false;
		$scope.oneYearFlag = false;
		$scope.fiveYearFlag = false;
		$scope.tenYearFlag = false;
		$scope.threeYearFlag = false;
		$scope.twoYearFlag = false;
		
		$scope.filterDates = function() {
			$scope.startMaxDate = new Date($scope.minDate);
			if($scope.portfromDate != '' && $scope.porttoDate != '') {
				$scope.period = undefined;
				if($scope.portfromDate > $scope.porttoDate) {
					$scope.errorFilter = true;
					$scope.errorFilterMsg = 'From Date should be less than To Date';
				} else if($scope.portfromDate < $scope.startMaxDate) {
					$scope.errorFilter = true;
					$scope.errorFilterMsg = 'From Date should not exceed '+ $filter('date')($scope.startMaxDate,'dd-MMM-yyyy');
				} else if($scope.porttoDate > $scope.endMaxDate) {
					$scope.errorFilter = true;
					$scope.errorFilterMsg = 'To Date should not exceed ' + $filter('date')($scope.endMaxDate,'dd-MMM-yyyy');
				} else {
					$scope.errorFilter = false;
					$scope.period = undefined;
					$scope.filterGraph();
				}
			}
		}

		$scope.getMinDate = function() {
			return $filter('date')(new Date($scope.minDate),'dd-MMM-yyyy');
		}

		$scope.restFilter = function() {
			var d = new Date();
			d.setMonth(d.getMonth() - 6);
			$scope.portfromDate = d;
			$scope.porttoDate = new Date();
			$scope.fromDate = d;
			$scope.toDate = new Date();
		}
		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};
		$scope.filterPeriod = function () {
			if($scope.period) {
				$scope.portfromDate = $scope.porttoDate = '';
				$scope.filterGraph();
			}
		}
        $scope.buildGridFinancialInfo = function(checkVal, val) {
			var periodTitle = '';
			if($scope.summPeriod != '') {
				switch ($scope.summPeriod) {
					case '7':
						periodTitle = '1 Week';
						break;
					case '30':
						periodTitle = '1 Month';
						break;
					case '180':
						periodTitle = '6 Months';
						break;
					case '2':
						periodTitle = '2 Years';
						break;
					case '3':
						periodTitle = '3 Years';
						break;
					case '5':
						periodTitle = '5 Years';
						break;
					case '10':
						periodTitle = '10 Years';
						break;
					case '90':
						periodTitle = '3 Months';
						break;
					case '270':
						periodTitle = '9 Months';
						break;
					default:
						break;
				}
			}
			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
            ycgmain.setHeaderText("Particulars");
			gridCgs.push(ycgmain);
			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			mCol.setHeaderText("");
			mCol.setFilterControl('TextInput');
			mCol.filterOperation = 'Contains';
			mCol.setDataField("rowName");
			mCol.headerAlign = "center";
			mCol.textAlign = "left"
			mCol.paddingLeft = 12;
            mCol.setWidth(220);
			mCol.sortable = false;
			mCol.headerWordWrap = true;
			mCol.enableHierarchicalNestIndent = true;
			mCol.headerHorizontalGridLineColor = "0x000000";
			mCol.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols.push(mCol);

			var ycgmain1 = new flexiciousNmsp.FlexDataGridColumnGroup();
            ycgmain1.setHeaderText("Date");
			gridCgs.push(ycgmain1);
			var allheadCols1 = [];
			var mCol1 = new flexiciousNmsp.FlexDataGridColumn();
			mCol1.setHeaderText("");
			mCol1.setLabelFunction2($scope.getDate);
			mCol1.headerAlign = "center";
			mCol1.textAlign = "center"
			//mCol1.setColumnWidthMode("fixed");
            mCol1.setWidth(150);
			mCol1.sortable = false;
			mCol1.headerWordWrap = true;
			mCol1.enableHierarchicalNestIndent = true;
			mCol1.headerHorizontalGridLineColor = "0x000000";
			mCol1.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols1.push(mCol1);

            var ycgmain2 = new flexiciousNmsp.FlexDataGridColumnGroup();
            ycgmain2.setHeaderText("Value");
			gridCgs.push(ycgmain2);
			var allheadCols2 = [];
			var mCol2 = new flexiciousNmsp.FlexDataGridColumn();
			mCol2.setHeaderText($scope.dataDenomination);
			mCol2.setDataField("value");
			mCol2.headerAlign = "center";
			mCol2.textAlign = "center"
			//mCol2.setColumnWidthMode("fixed");
            mCol2.setWidth(150);
			mCol2.sortable = false;
			mCol2.headerWordWrap = true;
			mCol2.enableHierarchicalNestIndent = true;
			mCol2.headerHorizontalGridLineColor = "0x000000";
			mCol2.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols2.push(mCol2);

            var ycgmain3 = new flexiciousNmsp.FlexDataGridColumnGroup();
            ycgmain3.setHeaderText($scope.frequency);
			gridCgs.push(ycgmain3);
			var allheadCols3 = [];
			var mColDaily1 = new flexiciousNmsp.FlexDataGridColumn();
			mColDaily1.setHeaderText("Change");
			mColDaily1.setLabelFunction2($scope.getProgressIndicatorAbs);
			mColDaily1.textAlign = "center";
			mColDaily1.headerAlign = "center";
			//mColDaily1.setColumnWidthMode("fixed");
            mColDaily1.setWidth(85);
			mColDaily1.sortable = false;
			mColDaily1.headerWordWrap = true;
			mColDaily1.enableHierarchicalNestIndent = true;
			mColDaily1.headerHorizontalGridLineColor = "0x000000";
			mColDaily1.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols3.push(mColDaily1);

            var mColDaily2 = new flexiciousNmsp.FlexDataGridColumn();
			mColDaily2.setHeaderText("Absolute");
			mColDaily2.setDataField("absVal");
			mColDaily2.headerAlign = "center";
			mColDaily2.textAlign = "center"
			//mColDaily2.setColumnWidthMode("fixed");
            mColDaily2.setWidth(85);
			mColDaily2.sortable = false;
			mColDaily2.headerWordWrap = true;
			mColDaily2.enableHierarchicalNestIndent = true;
			mColDaily2.headerHorizontalGridLineColor = "0x000000";
			mColDaily2.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols3.push(mColDaily2);

            var mColDaily3 = new flexiciousNmsp.FlexDataGridColumn();
			mColDaily3.setHeaderText("%");
			mColDaily3.setDataField("absPerc");
			mColDaily3.headerAlign = "center";
			mColDaily3.textAlign = "center"
			//mColDaily3.setColumnWidthMode("fixed");
            mColDaily3.setWidth(85);
			mColDaily3.sortable = false;
			mColDaily3.headerWordWrap = true;
			mColDaily3.enableHierarchicalNestIndent = true;
			mColDaily3.headerHorizontalGridLineColor = "0x000000";
			mColDaily3.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols3.push(mColDaily3);

            var ycgmain4 = new flexiciousNmsp.FlexDataGridColumnGroup();
            ycgmain4.setHeaderText("Year");
			gridCgs.push(ycgmain4);
			var allheadCols4 = [];
			var mColYear1 = new flexiciousNmsp.FlexDataGridColumn();
			mColYear1.setHeaderText("Change");
			mColYear1.setLabelFunction2($scope.getProgressIndicatorYear);
			mColYear1.headerAlign = "center";
			mColYear1.textAlign = "center";
			//mColYear1.setColumnWidthMode("fixed");
            mColYear1.setWidth(85);
			mColYear1.sortable = false;
			mColYear1.headerWordWrap = true;
			mColYear1.enableHierarchicalNestIndent = true;
			mColYear1.headerHorizontalGridLineColor = "0x000000";
			mColYear1.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols4.push(mColYear1);

            var mColYear2 = new flexiciousNmsp.FlexDataGridColumn();
            var asp = flexiciousNmsp.NumberFormatter;
			mColYear2.setHeaderText("Absolute");
			mColYear2.setDataField("yearChg");
			mColYear2.headerAlign = "center";
			mColYear2.textAlign = "center"
			//mColYear2.setColumnWidthMode("fixed");
            mColYear2.setWidth(85);
			mColYear2.sortable = false;
			mColYear2.headerWordWrap = true;
			mColYear2.enableHierarchicalNestIndent = true;
			mColYear2.headerHorizontalGridLineColor = "0x000000";
			mColYear2.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols4.push(mColYear2);

            var mColYear3 = new flexiciousNmsp.FlexDataGridColumn();
			mColYear3.setHeaderText("%");
			mColYear3.setDataField("yearChgPerc");
			mColYear3.headerAlign = "center";
			mColYear3.textAlign = "center"
			//mColYear3.setColumnWidthMode("fixed");
            mColYear3.setWidth(85);
			mColYear3.sortable = false;
			mColYear3.headerWordWrap = true;
			mColYear3.enableHierarchicalNestIndent = true;
			mColYear3.headerHorizontalGridLineColor = "0x000000";
			mColYear3.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols4.push(mColYear3);

            var ycgmain5 = new flexiciousNmsp.FlexDataGridColumnGroup();
            ycgmain5.setHeaderText("YTD");
			gridCgs.push(ycgmain5);
			var allheadCols5 = [];
			var mColYtd1 = new flexiciousNmsp.FlexDataGridColumn();
			mColYtd1.setHeaderText("Change");
			mColYtd1.setLabelFunction2($scope.getProgressIndicatorYtd);
			mColYtd1.headerAlign = "center";
			mColYtd1.textAlign = "center";
			//mColYtd1.setColumnWidthMode("fixed");
            mColYtd1.setWidth(85);
			mColYtd1.sortable = false;
			mColYtd1.headerWordWrap = true;
			mColYtd1.enableHierarchicalNestIndent = true;
			mColYtd1.headerHorizontalGridLineColor = "0x000000";
			mColYtd1.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols5.push(mColYtd1);

            var mColYtd2 = new flexiciousNmsp.FlexDataGridColumn();
			mColYtd2.setHeaderText("Absolute");
			mColYtd2.setDataField("ytdChg");
			mColYtd2.headerAlign = "center";
			mColYtd2.textAlign = "center"
			//mColYtd2.setColumnWidthMode("fixed");
            mColYtd2.setWidth(85);
			mColYtd2.sortable = false;
			mColYtd2.headerWordWrap = true;
			mColYtd2.enableHierarchicalNestIndent = true;
			mColYtd2.headerHorizontalGridLineColor = "0x000000";
			mColYtd2.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols5.push(mColYtd2);

            var mColYtd3 = new flexiciousNmsp.FlexDataGridColumn();
			mColYtd3.setHeaderText("%");
			mColYtd3.setDataField("ytdChgPerc");
			mColYtd3.headerAlign = "center";
			mColYtd3.textAlign = "center"
			//mColYtd3.setColumnWidthMode("fixed");
            mColYtd3.setWidth(85);
			mColYtd3.sortable = false;
			mColYtd3.headerWordWrap = true;
			mColYtd3.enableHierarchicalNestIndent = true;
			mColYtd3.headerHorizontalGridLineColor = "0x000000";
			mColYtd3.columnGroupHorizontalGridLineColor = "0x000000";
            allheadCols5.push(mColYtd3);

			if($scope.summPeriod != '') {
				var ycgmain6 = new flexiciousNmsp.FlexDataGridColumnGroup();
				ycgmain6.setHeaderText(periodTitle);
				gridCgs.push(ycgmain6);
				var allheadCols6 = [];
				var mColPeriod1 = new flexiciousNmsp.FlexDataGridColumn();
				mColPeriod1.setHeaderText("Change");
				mColPeriod1.setLabelFunction2($scope.getProgressIndicatorPeriod);
				mColPeriod1.headerAlign = "center";
				mColPeriod1.textAlign = "center";
				//mColYtd1.setColumnWidthMode("fixed");
				mColPeriod1.setWidth(85);
				mColPeriod1.sortable = false;
				mColPeriod1.headerWordWrap = true;
				mColPeriod1.enableHierarchicalNestIndent = true;
				mColPeriod1.headerHorizontalGridLineColor = "0x000000";
				mColPeriod1.columnGroupHorizontalGridLineColor = "0x000000";
				allheadCols6.push(mColPeriod1);
	
				var mColPeriod2 = new flexiciousNmsp.FlexDataGridColumn();
				mColPeriod2.setHeaderText("Absolute");
				mColPeriod2.setDataField("periodChg");
				mColPeriod2.headerAlign = "center";
				mColPeriod2.textAlign = "center"
				//mColPeriod2.setColumnWidthMode("fixed");
				mColPeriod2.setWidth(85);
				mColPeriod2.sortable = false;
				mColPeriod2.headerWordWrap = true;
				mColPeriod2.enableHierarchicalNestIndent = true;
				mColPeriod2.headerHorizontalGridLineColor = "0x000000";
				mColPeriod2.columnGroupHorizontalGridLineColor = "0x000000";
				allheadCols6.push(mColPeriod2);
	
				var mColPeriod3 = new flexiciousNmsp.FlexDataGridColumn();
				mColPeriod3.setHeaderText("%");
				mColPeriod3.setDataField("periodPerc");
				mColPeriod3.headerAlign = "center";
				mColPeriod3.textAlign = "center"
				//mColPeriod3.setColumnWidthMode("fixed");
				mColPeriod3.setWidth(85);
				mColPeriod3.sortable = false;
				mColPeriod3.headerWordWrap = true;
				mColPeriod3.enableHierarchicalNestIndent = true;
				mColPeriod3.headerHorizontalGridLineColor = "0x000000";
				mColPeriod3.columnGroupHorizontalGridLineColor = "0x000000";
				allheadCols6.push(mColPeriod3);
			}

            ycgmain.setColumns(allheadCols);
            ycgmain1.setColumns(allheadCols1);
            ycgmain2.setColumns(allheadCols2);
            ycgmain3.setColumns(allheadCols3);
            ycgmain4.setColumns(allheadCols4);
            ycgmain5.setColumns(allheadCols5);
			if($scope.summPeriod != '') {
				ycgmain6.setColumns(allheadCols6);
			}
			financialGrid.getColumnLevel().setGroupedColumns(gridCgs);
			financialGrid.enableExport = true;
			financialGrid.rebuild();
			financialGrid.validateNow();
		}

		$scope.getProgressIndicatorPeriod = function(rowData, column) {
			if(rowData.periodChg == null) {
				return '';
			} else {
				if(rowData.periodProgress) {
					return '<i><img class="template-img" src="content/images/arrow_up.png"  width="16px" height="16px"/></i>';
				} else {
					return '<i><img class="template-img" src="content/images/arrow_down.png"  width="16px" height="16px"/></i>';
				}
			}
		}

        $scope.dynamicColumnsGridForIndustryBenchmarkFinancialInfo = function (
            evt) {
            financialGrid = evt.target;
            $scope.buildGridFinancialInfo();
        }
        $scope.graphShopwFlag = true;
        $scope.updateCategories = function() {
			$scope.selectedSubCategory = '1';
			if($scope.selectedCategory == '16') {
				$scope.selectedSubCategory = '2';
			}
			$scope.porttoDate = '';
			$scope.portfromDate = '';
			$scope.selectedGraph = "Line Graph";
			$scope.setDefaultPeriods();
			var summaryCriteria = {
				summaryPeriod: $scope.summPeriod,
				selectedCategory: $scope.selectedCategory
			};
			if($scope.categories.length > 0) {
				$scope.source = _.find($scope.categories, ['id', parseInt($scope.selectedCategory)]).dataSource;
			}
			EconomicIndicatorService.getEcoIndicatorData(summaryCriteria).then(
				function(successData) {
                    $scope.industryBenchmarkFinancialOutputData = {
                        dataProvider : successData.data.summary,
                        delegate : $scope
                    };
					$scope.summaryData = successData.data.summary
					$scope.graphData = successData.data.graph;
					$scope.subCategories = successData.data.particulars;
					$scope.dataDenomination = successData.data.denomination;
					$scope.frequency = successData.data.frequency;
					$scope.minDate = successData.data.minDate;
					
					$scope.resetTimeframeFlags();
					$scope.updateTimeframe();
					if(	$scope.graphData.length > 0){
						$scope.initialise();
						$scope.graphShopwFlag = true;
						$scope.errorFilter = false;
						$scope.errorFilterMsg = "";
					}else{
						$scope.errorFilter = true;
						$scope.errorFilterMsg = "There is no data present for selected period.";
						$scope.graphShopwFlag = false;
					}
					$scope.filterGraph();
                    $timeout(function() {
                        $scope.buildGridFinancialInfo(true);
                    }, 100);
				}, function (errorData) {
					$scope.responseMessage = errorData.data;
				 }
			);
        }

		$scope.setDefaultPeriods = function() {
			switch ($scope.selectedCategory) {
				case '1':
				case '2':
				case '3':
				case '4':
				case '8':
					$scope.summPeriod = '7';
					$scope.period = '7';
					break;
				case '5':
				case '6':
				case '9':
				case '10':
				case '11':
					$scope.summPeriod = '30';
					$scope.period = '30';
					break;
				case '7':
				case '15':
				case '16':
				case '14':
				case '12':
				case '13':
					$scope.summPeriod = '180';
					$scope.period = '180';
					break;
				default:
					break;
			}
		}

		$scope.updatePeriod = function() {
			var summaryCriteria = {
				summaryPeriod: $scope.summPeriod,
				selectedCategory: $scope.selectedCategory
			};
			
			EconomicIndicatorService.getEcoIndicatorData(summaryCriteria).then(
				function(successData) {
                    $scope.industryBenchmarkFinancialOutputData = {
                        dataProvider : successData.data.summary,
                        delegate : $scope
                    };
					$scope.summaryData = successData.data.summary;
					$scope.subCategories = successData.data.particulars;
					$scope.dataDenomination = successData.data.denomination;
					$scope.frequency = successData.data.frequency;

					$scope.resetTimeframeFlags();
					$scope.updateTimeframe();
					if(	$scope.graphData.length > 0){
						$scope.initialise();
						$scope.graphShopwFlag = true;
						$scope.errorFilter = false;
						$scope.errorFilterMsg = "";
					}else{
						$scope.errorFilter = true;
						$scope.errorFilterMsg = "There is no data present for selected period.";
						$scope.graphShopwFlag = false;
					}
                    $timeout(function() {
                        $scope.buildGridFinancialInfo(true);
                    }, 100);
				}, function (errorData) {
					$scope.responseMessage = errorData.data;
				 }
			);
        }

		$scope.resetTimeframeFlags = function() {
			$scope.oneWeekFlag = false;
			$scope.oneMonFlag = false;
			$scope.threeMonFlag = false;
			$scope.sixMonFlag = false;
			$scope.oneYearFlag = false;
			$scope.fiveYearFlag = false;
			$scope.tenYearFlag = false;
			$scope.threeYearFlag = false;
			$scope.twoYearFlag = false;
			$scope.nineMonFlag = false;
		}

		$scope.updateTimeframe = function() {
			if($scope.frequency == 'Daily'){
				$scope.oneWeekFlag = true;
				$scope.oneMonFlag = true;
				$scope.threeMonFlag = true;
				$scope.sixMonFlag = true;
			}
			if($scope.frequency == 'Weekly'){
				$scope.oneMonFlag = true;
				$scope.threeMonFlag = true;
				$scope.sixMonFlag = true;
				$scope.oneYearFlag = true;
			}
			if($scope.frequency == 'Fortnightly'){
				$scope.oneMonFlag = true;
				$scope.sixMonFlag = true;
				$scope.oneYearFlag = true;
				$scope.threeYearFlag = true;
			}
			if($scope.frequency == 'Monthly'){
				$scope.sixMonFlag = true;
				$scope.oneYearFlag = true;
				$scope.threeYearFlag = true;
				$scope.fiveYearFlag = true;
			}
			if($scope.frequency == 'Quarterly'){
				$scope.sixMonFlag = true;
				$scope.nineMonFlag = true;
			}
			if($scope.selectedCategory == '16') {
				$scope.threeYearFlag = true;
			}
		}

		$scope.filterGraph = function() {
			$scope.errorFilter = false;
			var filter = {
				selectedCategory: $scope.selectedCategory,
				selectSubCategory: $scope.selectedSubCategory,
				selectedPeriod: $scope.period,
				fromDate: $scope.portfromDate,
				toDate: $scope.porttoDate
			}
			EconomicIndicatorService.filterGraph(filter).then(
				function(successData) {
					$scope.graphData = successData.data;
					
					if($scope.graphData.length <= 0){
						$scope.graphShopwFlag = false;
						$scope.errorFilter = true;
						$scope.errorFilterMsg = "There is no data present for selected period."
					}else{
						$scope.graphShopwFlag = true;
						$scope.initialise();
						$scope.errorFilter = false;
						$scope.errorFilterMsg ='';
					}
				}, function (errorData) {
					$scope.responseMessage = errorData.data;
				 }
			);
        }

	5



		$scope.getDate = function(rowData, column) {
            return $filter('date')(rowData.date,'dd-MMM-yyyy');
		}

		$scope.getProgressIndicatorYtd = function(rowData, column) {
			if(rowData.ytdChg == null) {
				return '';
			} else {
				if(rowData.ytdDiffProgress) {
					return '<i><img class="template-img" src="content/images/arrow_up.png"  width="16px" height="16px"/></i>';
				} else {
					return '<i><img class="template-img" src="content/images/arrow_down.png"  width="16px" height="16px"/></i>';
				}
			}
		}

		$scope.getProgressIndicatorYear = function(rowData, column) {
			if(rowData.yearChg == null) {
				return '';
			} else {
				if(rowData.yearDiffProgress) {
					return '<i><img class="template-img" src="content/images/arrow_up.png"  width="16px" height="16px"/></i>';
				} else {
					return '<i><img class="template-img" src="content/images/arrow_down.png"  width="16px" height="16px"/></i>';
				}
			}
			
		}

		$scope.getProgressIndicatorAbs = function(rowData, column) {
			if(rowData.absVal == null) {
				return '';
			} else {
				if(rowData.absDiffProgress) {
					return '<i><img class="template-img" src="content/images/arrow_up.png"  width="16px" height="16px"/></i>';
				} else {
					return '<i><img class="template-img" src="content/images/arrow_down.png"  width="16px" height="16px"/></i>';
				}
			}
			
		}
		$scope.getAllCategories = function() {
			EconomicIndicatorService.getAllCategories().then(
				function(successData) {
                    $scope.categories = successData.data;
					if($scope.categories.length > 0) {
						$scope.source = _.find($scope.categories, ['id', parseInt($scope.selectedCategory)]).dataSource;
					}
				}, function (errorData) {
					$scope.responseMessage = errorData.data;
				 }
			);
        }

		$scope.graphNames = ["Line Graph" , "Area Graph" ,"Bar Graph"];

		var gaugeChart = null;

		
		$scope.initialise = function() {
			var title = _.find($scope.subCategories, ['patId', parseInt($scope.selectedSubCategory)]).particulars;
			 var config_area_graph =
			 {
				"type": "serial",
				"theme": "none",
				"marginRight": 80,
				"dataProvider": $scope.graphData,
				"startDate": $scope.graphData[0].date,
				"endDate": $scope.graphData[$scope.graphData.length - 1].date,
				"valueAxes": [{
					"gridThickness":0,
					"position": "left",
					"title": title + " (" + $scope.dataDenomination + ")"
				}],
				"graphs": [{
					"id": "g1",
					"fillAlphas": 0.4,
					"valueField": "value",
					 "balloonText": "<div style ='font-size:14px;'><b style = 'padding-bottom : 4px;'> [[value]]</b></br> [[category]]</br> </div>"
					}],
				"chartScrollbar": {
					"scrollbarHeight": 40,
					"backgroundAlpha": 0,
					"selectedBackgroundAlpha": 0.1,
					"selectedBackgroundColor": "#888888",
					"graphFillAlpha": 0,
					"graphLineAlpha": 0.5,
					"selectedGraphFillAlpha": 0,
					"selectedGraphLineAlpha": 1,
					"autoGridCount": true,
					"color": "#AAAAAA"

				},
				"chartCursor": {
					"categoryBalloonEnabled": false,
					"categoryBalloonDateFormat": "DD-MMM-YYYY",
					"cursorPosition": "mouse",
					"cursorColor":"#000000",
					"cursorAlpha": 1,
					"zoomable": true
				},
				"categoryField": "date",
				"categoryAxis": {
					"dateFormats": [
						{"period":"mm","format":"JJ:NN"},
							{"period":"hh","format":"JJ:NN"},
							{
							"period": "DD",
							"format": "DD MMM"
						}, {
							"period": "WW",
							 "format": "DD MMM"
						 }, {
							"period": "MM",
							 "format": "MMM YYYY"
						 }, {
							 "period": "YYYY",
							 "format": "MMM YYYY"
						 }],
					//"minPeriod": "mm",
					"axisColor": "#555555",
					"gridAlpha": 0.1,
					"gridColor": "#FFFFFF",
					"gridThickness": 0,
					"autoGridCount": true,
					"parseDates": true,
					 "boldLabels":true
				}, "export": {
					"enabled": true,
					"position":"bottom-right"
				}
				
			};
			// var startDate = $scope.graphData[0];
			// var endDate = $scope.graphData[$scope.graphData.length - 1];
			// $scope.graphData[0].forceShow = true;
			// $scope.graphData[$scope.graphData.length - 1].forceShow = true
		// 	var config_area_graph =
		// 	{
		// 	   "type": "serial",
		// 	   "theme": "none",
		// 	   "marginRight": 80,
		// 	   "dataProvider": $scope.graphData,
		// 	   "startDate": $scope.graphData[0].date,
		// 		"endDate": $scope.graphData[$scope.graphData.length - 1].date,
		// 	   "valueAxes": [{
		// 		   "gridThickness":0,
		// 		   "position": "left",
		// 		   "title": title + " (" + $scope.dataDenomination + ")"
		// 	   }],
		// 	   "graphs": [{
		// 		   "id": "g1",
		// 		   "fillAlphas": 0.4,
		// 		   "valueField": "value",
		// 			"balloonText": "<div style ='font-size:14px;'><b style = 'padding-bottom : 4px;'> [[value]]</b></br> [[category]]</br> </div>"
		// 		   }],
		// 	   "chartScrollbar": {
		// 		   "scrollbarHeight": 40,
		// 		   "backgroundAlpha": 0,
		// 		   "selectedBackgroundAlpha": 0.1,
		// 		   "selectedBackgroundColor": "#888888",
		// 		   "graphFillAlpha": 0,
		// 		   "graphLineAlpha": 0.5,
		// 		   "selectedGraphFillAlpha": 0,
		// 		   "selectedGraphLineAlpha": 1,
		// 		   "autoGridCount": true,
		// 		   "color": "#AAAAAA"

		// 	   },
		// 	   "chartCursor": {
		// 		   "categoryBalloonEnabled": false,
		// 		   "categoryBalloonDateFormat": "DD-MMM-YYYY",
		// 		   "cursorPosition": "mouse",
		// 		   "cursorColor":"#000000",
		// 		   "cursorAlpha": 1,
		// 		   "zoomable": true
		// 	   },
		// 	   "categoryField": "date",
		// 	   "categoryAxis": {
		// 		   "dateFormats": [
		// 			   {"period":"mm","format":"JJ:NN"},
		// 				   {"period":"hh","format":"JJ:NN"},
		// 				   {
		// 				   "period": "DD",
		// 				   "format": "DD MMM"
		// 			   }, {
		// 				   "period": "WW",
		// 					"format": "DD MMM"
		// 				}, {
		// 				   "period": "MM",
		// 					"format": "MMM YYYY"
		// 				}, {
		// 					"period": "YYYY",
		// 					"format": "MMM YYYY"
		// 				}],
		// 		   //"minPeriod": "mm",
		// 		   "axisColor": "#555555",
		// 		   "gridAlpha": 0.1,
		// 		   "gridColor": "#FFFFFF",
		// 		   "gridThickness": 0,
		// 		   "autoGridCount": true,
		// 		   "parseDates": true,
		// 			"boldLabels":true
		// 	   }, "export": {
		// 		   "enabled": true,
		// 		   "position":"bottom-right"
		// 	   }
			   
		//    };

			var config_line_graph = {
				"type": "serial",
				"theme": "none",
				"autoMarginOffset": 20,
				"marginRight": 80,
				"dataProvider": $scope.graphData,
				"startDate": $scope.graphData[0].date,
				"endDate": $scope.graphData[$scope.graphData.length - 1].date,
				"valueAxes": [{
					"gridThickness": 0,
					"id": "volumeAxis",
					"axisAlpha": 0,
					"gridAlpha": 0,
					"position": "left",
					"title": title + " (" + $scope.dataDenomination + ")"
				}, {
					"id": "indexAxis",
					"axisAlpha": 0,
					"gridAlpha": 0,
					"position": "left"
				}],

				"graphs": [{
					"id": "fromGraph",
					"valueField": "value",
					"lineThickness": 2,
					"bullet": "round",
					"bulletAlpha": 0,
					"bulletSize": 8,
					"bulletBorderAlpha": 0,
					"balloonText": "<div style ='font-size:14px;'><b style = 'padding-bottom : 4px;'>[[value]]</b></br> [[category]]</br> </div>"

				}, {}],
				"chartCursor": {
					"enabled": true,
					//"fullWidth": true,
					//"cursorAlpha": 0.05,
					"valueLineEnabled": false,
					"valueLineAlpha": 0.5,
					"valueLineBalloonEnabled": false,
					"categoryBalloonEnabled": false,
					"categoryLineEnabled": false,
					//"cursorAlpha": 0,
					//"cursorColor":"#000000",
					"graphBulletAlpha": 1,
					"balloonPointerOrientation": "vertical",
					"cursorPosition": "mouse",
					"cursorColor": "#000000",
					"cursorAlpha": 1,
					"zoomable": true

				},
				"categoryField": "date",
				"categoryAxis": {
					"parseDates": true,
					"axisAlpha": 0,
					"gridAlpha": 0,
					"tickLength": 0,
					"dateFormats": [
						{ "period": "mm", "format": "JJ:NN" },
						{ "period": "hh", "format": "JJ:NN" },
						{
							"period": "DD",
							"format": "DD MMM"
						}, {
							"period": "WW",
							"format": "DD MMM"
						}, {
							"period": "MM",
							"format": "MMM YYYY"
						}, {
							"period": "YYYY",
							"format": "MMM YYYY"
						}],
					"gridThickness": 0,
					//"minPeriod":"mm"
				},
				"chartScrollbar": {
					"scrollbarHeight": 40,
					"backgroundAlpha": 0,
					"selectedBackgroundAlpha": 0.1,
					"selectedBackgroundColor": "#888888",
					"graphFillAlpha": 0,
					"graphLineAlpha": 0.5,
					"selectedGraphFillAlpha": 0,
					"selectedGraphLineAlpha": 1,
					"autoGridCount": true,
					"color": "#AAAAAA"
				},
				"balloon": {
					"offsetX": 50,
					"offsetY": 8,
					"fixedPosition": false

				},
				"export": {
					"enabled": true,
					"position": "bottom-right"
				}
			};

			var config_bar_graph = {
				"type": "serial",
				"theme": "none",
				"dataProvider": $scope.graphData,
				"valueAxes": [{
					"gridThickness": 0,
					"gridColor": "#FFFFFF",
					"gridAlpha": 0.2,
					"dashLength": 0,
					"title": title + " (" + $scope.dataDenomination + ")"
				}],
				"gridAboveGraphs": true,
				"startDate": $scope.graphData[0].date,
				"endDate": $scope.graphData[$scope.graphData.length - 1].date,
				"startDuration": 0,
				"graphs": [{
					"balloonText": " <div style ='font-size:14px;'><b style = 'padding-bottom : 4px;'> [[value]]</b></br> [[category]]</br> </div>",
					"fillAlphas": 0.8,
					"lineAlpha": 0.2,
					"type": "column",
					"valueField": "value",
					"fixedColumnWidth": 5,
					"bullet": "round",
					"bulletAlpha": 0,
					"bulletSize": 8,
					"bulletBorderAlpha": 0,
				}],
				"chartCursor": {
					"categoryBalloonEnabled": false,
					"categoryBalloonDateFormat": "DD-MMM-YYYY",
					"zoomable": true,
					"cursorColor": "#000000",
					"cursorPosition": "mouse",
					"cursorColor": "#000000",
					"cursorAlpha": 1,
					"graphBulletAlpha": 1,
					"balloonPointerOrientation": "vertical"
				},
				"chartScrollbar": {
					"scrollbarHeight": 40,
					"backgroundAlpha": 0,
					"selectedBackgroundAlpha": 0.1,
					"selectedBackgroundColor": "#888888",
					"graphFillAlpha": 0,
					"graphLineAlpha": 0.5,
					"selectedGraphFillAlpha": 0,
					"selectedGraphLineAlpha": 1,
					"autoGridCount": true,
					"color": "#AAAAAA"
				},
				"categoryField": "date",
				"categoryAxis": {
					"dateFormats": [
						{ "period": "mm", "format": "JJ:NN" },
						{ "period": "hh", "format": "JJ:NN" },
						{
							"period": "DD",
							"format": "DD MMM"
						}, {
							"period": "WW",
							"format": "DD MMM"
						}, {
							"period": "MM",
							"format": "MMM YYYY"
						}, {
							"period": "YYYY",
							"format": "MMM YYYY"
						}],
					//"minPeriod":"mm",
					"parseDates": true,
					"autoGridCount": true,
					"axisColor": "#555555",
					"gridAlpha": 0.1,
					"gridColor": "#FFFFFF",
					"gridThickness": 0,
					"gridCount": 50,
					"boldLabels": true
				}, "export": {
					"enabled": true,
					"position": "bottom-right",

				}

			}


			if ($scope.selectedGraph == "Line Graph") {
				gaugeChart = AmCharts.makeChart("chartDivBarChart", config_line_graph);
			}
			else if ($scope.selectedGraph == "Area Graph") {
				gaugeChart = AmCharts.makeChart("chartDivBarChart", config_area_graph);
			}
			else if ($scope.selectedGraph == "Bar Graph") {
				gaugeChart = AmCharts.makeChart("chartDivBarChart", config_bar_graph);

			}
			gaugeChart.addListener("rendered", zoomChart);

			zoomChart();

			function zoomChart() {
				gaugeChart.zoomToIndexes(0, gaugeChart.dataProvider.length - 1);
			}
			
			$scope.$on("downloadImages",function($event, message){
				gaugeChart["export"].capture({}, function() {
				    // SAVE TO PNG
				    this.toPNG({}, function(base64) {
				    	$scope.exportdata[$scope.id]=base64;
				    	$scope.$emit("imageextractedCapital",{'type':$scope.id,'base64':base64});
				    });
				});
			});
			
						
		}

		$scope.downloadSummary = function(templateType) {
			var summaryCriteria = {
				summaryPeriod: $scope.summPeriod,
				selectedCategory: $scope.selectedCategory
			};
			$http({
					url : 'api/aifbenchmark/excelexport',
					method : 'POST',
					data: summaryCriteria,
					responseType : 'arraybuffer'
				}).success(
						function(response) {
							var isIE = false || !!document.documentMode;
							$scope.response = response;
							var templateName = 'EcoIndicatorSummary.xlsx';
							var blob = new Blob(
									[ response ],
									{
										type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
									});
							if (isIE) {
								window.navigator
										.msSaveOrOpenBlob(
												blob,
												'EcoIndicatorSummary.xlsx');
							} else {
								var anchor = angular
										.element('<a/>');
								var blob = new Blob(
										[ response ],
										{
											type : 'application/vnd.ms-excel'
										})
								var objectUrl = (window.URL || window.webkitURL)
										.createObjectURL(blob);
								anchor.css({
									display : 'none'
								});
								angular.element(
										document.body)
										.append(anchor); 
								anchor
										.attr({
											href : objectUrl,
											target : '_self',
	
											download : templateName
										})[0].click();
	
								anchor.remove();
							}
						})
		}

		$scope.getParticular = function(patName) {
			return patName.substring(patName.lastIndexOf(';') + 1, patName.length);
		}

		$scope.getAllCategories();
        $scope.updateCategories($scope.selectedCategory);
    }
})();